export default {
  "b2b.projekt-vytvoreni.title.vytvoreni": "New project",
  "b2b.projekt-vytvoreni.title.edit": "Edit project",
  "b2b.projekt-vytvoreni.field.nazev.label": "Name",
  "b2b.projekt-vytvoreni.field.nazevEn.label": "Name (EN)",
  "b2b.projekt-vytvoreni.field.popis.label": "Description",
  "b2b.projekt-vytvoreni.field.popisEn.label": "Description (EN)",
  "b2b.projekt-vytvoreni.button.submit-vytvoreni": "Create",
  "b2b.projekt-vytvoreni.button.submit-edit": "Save",
  "b2b.projekt-vytvoreni.button.cancel": "Cancel",
  "b2b.projekt-vytvoreni.save-dialog.title": "Save project"
};
